module.exports = __webpack_public_path__ + "img/gmo_galaxytokens.df4cb71.png";